import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { authLink, getReturnTo } from '../lib/authNavigation';

/** Unauthenticated shell wrapping `/login` and `/signup` with brand + footer links. */
export function PublicLayout({ children }: { children: ReactNode }) {
  const returnTo = getReturnTo(useLocation().search);
  return (
    <div className="public-shell">
      <div className="brand">
        <h1>
          AstdZ<span style={{ color: 'var(--color-accent)' }}>_</span>
          {' '}<span style={{ color: 'var(--color-warn)', fontSize: '0.55em', verticalAlign: 'middle' }}>[BETA]</span>
        </h1>
        <div className="tag">when the towers go down, the mesh goes up</div>
      </div>
      <div className="ascii-rule">━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━</div>
      <div className="panel">
        {children}
      </div>
      <div className="ascii-rule">━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━</div>
      <div className="below">
        <Link to={authLink('/login', returnTo)}>sign in</Link> ·{' '}
        <Link to={authLink('/signup', returnTo)}>create account</Link> ·{' '}
        <Link to="/docs">documentation</Link> ·{' '}
        <a href="https://astdz.com/how-it-works/">how it works demo</a> ·{' '}
        <a href="https://astdz.com">← astdz.com</a>
      </div>
      <div className="below" style={{ marginTop: 8 }}>
        <a href="https://decode.astdz.com/emrg" target="_blank" rel="noreferrer">→ free decoder · decode.astdz.com/emrg</a>
      </div>
    </div>
  );
}
